import { sessionPayload } from '../utils/session';
// src/components/Profile.js
import React, { useEffect, useState, useRef } from "react";
import { post, postFromData } from "../services/api";
import ENDPOINTS from "../utils/constants/endpoints";
import { color } from "../utils/constants/thems";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const navigate=useNavigate();
  const [profile, setProfile] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    name: "",
    designation: "",
    email: "",
    mobile: "",
    images: "",
  });
  const fileRef = useRef(null);
  const [loading, setLoading] = useState(false);

  // Fetch profile
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const payload = {
          token: localStorage.getItem("token"),
          users_id: sessionPayload().users_id,
          role_id: sessionPayload().role_id,
        };
        const res = await post(ENDPOINTS.AUTH.GET_PROFILE, payload);

        if (res?.status === "success") {
          const data = res.data.usersMst;
          setProfile(data);
          setForm({
            name: data.name || "",
            designation: data.designation || "",
            email: data.email || "",
            mobile: data.mobile || "",
            images: data.images || "",
          });
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageUpload = async (file) => {
    if (!file) return "";
    const fd = new FormData();
    fd.append("token", localStorage.getItem("token"));
    fd.append("users_id", sessionPayload().users_id);
    fd.append("role_id", sessionPayload().role_id);
    fd.append("images", file);

    try {
      const res = await postFromData(ENDPOINTS.AUTH.UPLOAD_PROFILE, fd);
      return (
        res?.data?.img_file ||
        res?.file_url ||
        res?.data?.file_url ||
        res?.url ||
        res?.data?.url ||

        ""
      );
    } catch (err) {
      console.error("Image upload error:", err);
      return "";
    }
  };

  const handleSave = async () => {
    //console.log(fileRef.current)
    setLoading(true);
    try {
      let uploadedImage = form.images;
      if (fileRef.current?.files[0]) {
        uploadedImage = await handleImageUpload(fileRef.current.files[0]);
        if (!uploadedImage) throw new Error('Profile image upload failed; existing image was preserved.');
      }

      const payload = {
        token: localStorage.getItem("token"),
        users_id: sessionPayload().users_id,
        role_id: sessionPayload().role_id,
        name: form.name,
        designation: form.designation,
        email: form.email,
        mobile: form.mobile,
        images: uploadedImage,
      };
      //console.log("Upload Payload", payload)
      const res = await post(ENDPOINTS.AUTH.EDIT_PROFILE, payload);

      if (res?.status === "success") {
        alert("Profile updated successfully!");
        setEditMode(false);
        setProfile({ ...form, images: uploadedImage });
      } else {
        alert(res?.["success message"] || "Failed to update profile.");
      }
    } catch (err) {
      console.error("Save profile error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!profile) return <div className="text-center mt-5">Loading profile...</div>;

  return (
    <div className="container px-0 px-sm-2 mt-2 mt-sm-4">
      <div className="row justify-content-center mx-0">
        <div className="col-lg-6 col-md-8 col-sm-12 px-0 px-sm-2">
          <div className="card shadow-lg p-3 p-sm-4">
            <div className="text-center mb-4">
              <img
                src={form.images || "/default-avatar.png"}
                alt="profile"
                className="rounded-circle border"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                }}
              />
            </div>

            {!editMode ? (
              <>
                <h4 className="text-center mb-1 text-break">{profile.name}</h4>
                <p className="text-center text-muted">{profile.designation}</p>
                <hr />
                <div className="px-2">
                  <p className="text-break"><strong>Email:</strong> {profile.email}</p>
                  <p><strong>Mobile:</strong> {profile.mobile}</p>
                </div>

                <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={() => setEditMode(true)}
                    style={{ background: color.background }}
                  >
                    Edit Profile
                  </button>
                   <button
                    className="btn btn-primary "
                    onClick={() => navigate("/changePassword")}
                    style={{ background: color.background }}
                  >
                    Change Password
                  </button>
                </div>
              </>
            ) : (
              <form>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Designation</label>
                  <input
                    name="designation"
                    value={form.designation}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    type="email"
                    className="form-control"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Mobile</label>
                  <input
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Profile Image</label>
                  <input ref={fileRef} type="file" className="form-control" />
                </div>

                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleSave}
                    disabled={loading}
                    style={{ background: color.background }}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setEditMode(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
